import { render, staticRenderFns } from "./QuestionBank.vue?vue&type=template&id=6181889a&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181889a",
  null
  
)

export default component.exports